export const media = {
  inline: true,
  attrs: {
    type: {
      default: ''
    },
    name: {
      default: ''
    },
    url: {
      default: ''
    },
    thumbUrl: {
      default: ''
    }
  },
  group: 'inline',
  draggable: true,
  selectable: false,
  parseDOM: [{
    tag: '.tap-editor-media',
    getAttrs(dom) {
      return {
        type: dom.getAttribute('data-type'),
        name: dom.getAttribute('data-name'),
        url: dom.getAttribute('data-url'),
        thumbUrl: dom.getAttribute('data-thumbUrl')
      };
    }
  }],
  toDOM(node) {
    const {
      name,
      type,
      url,
      thumbUrl
    } = node.attrs;
    const domAttrs = {
      class: 'tap-editor-media',
      'data-type': type,
      'data-name': name,
      'data-url': url,
      'data-thumbUrl': thumbUrl
    };
    return ['span', domAttrs];
  }
};